import React from 'react';
import {useHistory} from 'react-router'
import {makeStyles, Container, Grid, Paper, Dialog, AppBar, Toolbar, Slide, IconButton} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import EditLeaveForm from '../../LeaveApplication/component/Form'
import Balance from '../../LeaveApplication/component/Balance'
import RecentLeave from '../../LeaveApplication/component/RecentLeave'
import RecentLeaveCollection from '../../Function/RecentLeaveCollection'
import customAxios from "../../API/customAxios";
import Details from "../../MyLeave/component/Details";
import {useIntl} from 'react-intl';
import {checkUndefined} from "../../Function/globalFunction";
import MiniTable from "../../UIComponent/MiniTable";
import CompLeaveCollection from "../../Function/CompLeaveCollection";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: '#232F3E',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
    },
    subPaper: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Edit({handleClose, open, showId, type, isNewCompLeave, source}) {
    const mode = window.global.editMode;
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const [compLeaveRows, setCompLeaveRows] = React.useState([]);
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [application, setApplication] = React.useState({});
    const [showDetail, setShowDetail] = React.useState(false);
    const [rows, setRows] = React.useState([]);
    const [employneeDuty, setEmployneeDuty] = React.useState('');
    if (source) {
        isNewCompLeave = source == 'newCompLeave';
    }
    const page = isNewCompLeave ? 'Edit Comp Leave' : 'Edit Leave';

    React.useEffect(() => {
        let url = ''
        if (isNewCompLeave) {
            url = '/get_my_comp_leave_reqs/';
        } else {
            url = '/get_application/';
        }

        customAxios.get(url + showId)
            .then(res => {
                const response = isNewCompLeave ? res.data[0] : res.data;
                if (response) {
                    if (String(response.status) !== window.global.withdrawn) {
                        setShowDetail(true);
                    } else {
                        setShowDetail(false);
                    }
    
                    setApplication(response);
                    setRows(RecentLeaveCollection(response['recent_leave'], intl));
                    setShowCompetent(true);
                    setCompLeaveRows(CompLeaveCollection(response['comp_leave_balance'], intl));
                    setEmployneeDuty(response['staff_duty']);
                } else {
                    history.push('/home');
                }
            }, error => {
                history.push('/home');
            });
    }, []);

    return (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        backgroundColor: '#f0f2f5',
                        boxShadow: 'none',
                    },
                }}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Container className={classes.container}>
                {showCompetent ?
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={7}>
                            <Paper className={classes.mainPaper}>
                                <EditLeaveForm
                                    mode={mode}
                                    employeeId={application.employee.id}
                                    employeeName={application.employee.employee_name}
                                    staffDuty={application.employee.staff_duty}
                                    annualAllowances={application.employee.annual_allowances}
                                    annualTotal={application.employee.annual_total}
                                    editApplicationId={application.id}
                                    editTypeId={application.type_id}
                                    editTypeName={intl.formatMessage({id: 'guideline.' + application.type.name})}
                                    editStartDate={application.start_date}
                                    editStartTime={application.start_time}
                                    editUntilDate={application.until_date}
                                    editEndTime={application.end_time}
                                    editPeriod={application.period}
                                    editReason={checkUndefined(application.reason)}
                                    editAttachment={application.attachment}
                                    editAttachmentPath={checkUndefined(application.attachment_path)}
                                    editStatus={application.status}
                                    compLeaveRows={compLeaveRows}
                                    isNewCompLeave={isNewCompLeave}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={12} lg={5}>
                            <Paper className={classes.subPaper}>
                                <Balance mode={mode} annualAllowances={application.employee.annual_allowances}/>
                            </Paper>
                            {employneeDuty === 'OFFICE HOURS' ? (
                                <Paper className={classes.subPaper}>
                                    <MiniTable rows={compLeaveRows}/>
                                </Paper>
                            ) : ''}
                            {showDetail &&
                                <Paper className={classes.subPaper}>
                                    <Details handleClose={null} open={null} showId={showId} page={page}/>
                                </Paper>
                            }
                            <Paper className={classes.subPaper}>
                                <RecentLeave rows={rows}/>
                            </Paper>
                        </Grid>
                    </Grid>
                    :
                    <div className={classes.circularProgress}>
                        <CircularProgress/>
                    </div>
                }
            </Container>
        </Dialog>
    )
}
